import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import commonV2 from './commons/v2/common'
import ModalAlertV2 from '@/components/v2/Modal/Alert'
import jQuery from 'jquery'
import { createPinia } from 'pinia'
import LoadScript from 'vue-plugin-load-script'

global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')

const app = createApp(App)
app.use(router)
app.use(store)
app.use(LoadScript)

const pinia = createPinia()
app.use(pinia)

app.component('modal-alert-v2', ModalAlertV2)

/**
 * URLからWebViewバージョンを判断するための正規表現を生成する
 *
 * @param {string} version - バージョン識別子
 * @returns {RegExp} - 指定されたバージョンパスにマッチする正規表現
 */
const injectionMatch = (version) => {
  return new RegExp(`/carwash/${version}/`)
}

if (window.location.href.match(injectionMatch('v2'))) {
  app.mixin(commonV2)
}

app.config.globalProperties.$filters = {
  addComma (val) {
    return val.toLocaleString()
  }
}

app.mount('#app')
